module.exports = __webpack_public_path__ + "static/home-about-a8eb9aaf5e348097c1643cc213315586.jpg";